<div class="card wd">
  <form class="center">
    <h1>Create Temporary User</h1>
  </form>

  <div class="col-md-6 FormAllaign">
    
    <!-- User Name -->
    <div class="form-group">
      <label>User Name</label><span class="error">{{username_error}}</span>
      <input type="text" class="form-control" placeholder="User name" name="username" 
             [(ngModel)]="data.username" (ngModelChange)="valuechange1($event)">
    </div>

    <!-- Password -->
    <div class="form-group">
      <label>Password</label><span class="error">{{password_error}}</span>
      <div class="password-input-wrapper">
        <input [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="password" 
               name="password" [(ngModel)]="data.password" (ngModelChange)="valuechange2($event)">
        <span class="password-toggle-icon" (click)="togglePasswordVisibility()">
          <i [class]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>
      </div>
    </div>

    <!-- Confirm Password -->
    <div class="form-group">
      <label>Confirm Password</label><span class="error">{{doesntMatch}}</span>
      <div class="password-input-wrapper">
        <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control" placeholder="Confirm password" 
               name="Cpassword" [(ngModel)]="data.confirmPassword" (ngModelChange)="valuechange3($event)">
        <span class="password-toggle-icon" (click)="toggleConfirmPasswordVisibility()">
          <i [class]="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>
      </div>
    </div>

    <!-- User Type -->
    <div class="form-group">
      <label>User type</label><span class="error">{{user_type_error}}</span>
      <select class="form-control" [(ngModel)]="data.user_type" (ngModelChange)="valuechange4($event)">
        <option value="">Select User Type</option>
        <option *ngFor="let item of userTypedropdown">{{item.name}}</option>
      </select>
    </div>

    <div class="form-group">
  <label>Employee Name <span class="text-danger">*</span></label>
  <span class="error">{{employee_name_error}}</span>
  <input type="text" class="form-control" placeholder="Enter employee name" 
         name="employee_name" [(ngModel)]="data.employee_name" 
         (ngModelChange)="valuechange5($event)">
</div>

    <!-- Select Employee -->
    <!-- <div class="form-group">
      <label>Select Employee</label><span class="error">{{employee_name_error}}</span>
      <div class="input-group search-input-group">
        <input type="search" class="form-control" placeholder="Search employee" 
               [(ngModel)]="data.employee_name" (ngModelChange)="valuechange5($event); SearchEmployee();">
        <button type="button" class="btn btn-search" (click)="SearchEmployee();">
          <i class="fa fa-search"></i>
        </button>
      </div>
      <div class="card card-default employee-dropdown" *ngIf="isShownEmployee">
        <div *ngFor="let c of employee">
          <h4 class="font" (click)="getEmployeeId(c.employee_id, c.employee_name)">
            <b>{{c.employee_name}}</b>
          </h4>
        </div>
      </div>
    </div> -->

    <!-- Create Button -->
    <button type="submit" class="btn btn-success btn_allign" (click)="Create();">Create Temporary User</button>

  </div>
</div>

<!-- Toast Container -->
<div class="toast-container-custom" *ngIf="toastMessage">
  <div class="toast-custom" [ngClass]="toastType">
    <div class="toast-icon-custom">
      <i [class]="toastType === 'success' ? 'fa fa-check' : 'fa fa-times'"></i>
    </div>
    <div class="toast-content-custom">
      <p class="toast-message-custom">{{ toastMessage }}</p>
    </div>
  </div>
</div>